import { Component, OnInit } from '@angular/core';

import {RootScopeService} from '../../core/shared-service/root-scope.service';
import { RootScopeDeclare } from '../../core/rootscope-declare';

@Component({
  selector: 'app-shop',
  templateUrl: './shop.component.html',
  styleUrls: ['./shop.component.css']
})
export class ShopComponent implements OnInit {

  rootScopeData: RootScopeDeclare;

  constructor(private rootScopeService: RootScopeService) { }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => this.rootScopeData = rootScopeData);
  }

  setPageName(): void {
    this.rootScopeData.pageName = 'shop';
  }

  ngOnInit() {
    this.getRootScopeData();
    this.setPageName();
  }

}
